import { useState } from 'react';

import { useFormState } from 'react-final-form';

import FormRow from 'components/FormRow';
import { InputWithField } from 'components/Input';
import SectionHeading from 'components/Text/SectionHeading';
import { usePartnerConfig } from 'config/partner/hooks';
import { BANK_DETAILS_IBAN } from 'modules/Inquiry/Form/formFields';
import { useTranslations } from 'utils/hooks/useTranslations';

export const IbanField = () => {
  const t = useTranslations('pages.companyDetails.sections.bankDetails');
  const {
    details: { fullName: partnerName },
  } = usePartnerConfig();
  const { values } = useFormState();

  const ibanForm = values[BANK_DETAILS_IBAN] ? `${values[BANK_DETAILS_IBAN]}` : '';

  const [ibanValue, setIban] = useState(ibanForm);

  function handleIbanChange(value: string) {
    setIban(value.toUpperCase());
  }

  return (
    <>
      <SectionHeading>{t('fields.iban.info', { partnerName })}</SectionHeading>
      <FormRow>
        <InputWithField
          name={BANK_DETAILS_IBAN}
          onChange={handleIbanChange}
          value={ibanValue}
          placeholder={t('fields.iban.placeholder')}
          noWhiteSpaces={true}
        />
      </FormRow>
    </>
  );
};
